import {
    Model
} from '@vuex-orm/core'

export default class Activity extends Model {

    static entity = 'activity'

    static fields() {
        return {
            id: this.attr(null),
            event: this.attr(''),
            created_at: this.attr('')
        }
    }
}